import { FC } from 'react';

import EyeSvg from '@/assets/iconly/Show.svg';

import { IconSummary } from './icon-summary';

export const ReadTime: FC<{ readTime: number }> = ({ readTime }) => (
  <IconSummary icon={<EyeSvg />} label={`${readTime} mins`} />
);
